var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.06 6.945a2.63 2.63 0 00-1.856-1.857C18.567 4.65 12 4.65 12 4.65s-6.567 0-8.204.44a2.63 2.63 0 00-1.857 1.856C1.5 8.582 1.5 12 1.5 12s0 3.417.44 5.054a2.63 2.63 0 001.856 1.857c1.637.44 8.204.44 8.204.44s6.567 0 8.204-.44a2.63 2.63 0 001.857-1.857C22.5 15.417 22.5 12 22.5 12s-.002-3.418-.44-5.055z",
    fill: "red"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.898 15.15L15.354 12 9.898 8.85v6.3z",
    fill: "#fff"
  })));
}

export default SvgIconYoutube;